import pLimit from 'p-limit'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { ChangeOrderEvent, ChangeOrderFilters, ManualChangeOrder, ChangeOrder } from '../types/Work/ChangeOrder'
import { PaginatedChangeOrders } from '../types/Work/ChangeOrder'
import { getAll, post } from './CommonServices/httpService'
import { ImportResponse } from '../types/Upload/ImportResponse'
import { showErrorToast } from './CommonServices/alertServices'

dayjs.extend(utc)

export const getChangeOrders = async (filters: ChangeOrderFilters) => {
	const queryParams = new URLSearchParams()

	if (filters.status) queryParams.append('status', filters.status)
	if (filters.reportedById) queryParams.append('reportedById', filters.reportedById.toString())
	if (filters.reportedOn)
		queryParams.append('reportedOn', dayjs(filters.reportedOn).utc().toISOString())
	if (filters.searchWorkItem) queryParams.append('searchWorkItem', filters.searchWorkItem)
	if (filters.page) queryParams.append('page', filters.page.toString())
	if (filters.surveyId) queryParams.append('surveyId', filters.surveyId.toString())

	const queryString = queryParams.toString()
	const url = `/ChangeOrders${queryString ? `?${queryString}` : ''}`

	const response = await getAll<PaginatedChangeOrders>(url)
	return response.data
}

export const getChangeOrderAttachments = async (changeOrderId: number) => {
	const url = `/ChangeOrders/${changeOrderId}/Attachments`
	const response = await getAll<ImportResponse[]>(url)
	return response.data.map((attach) => `${attach.uploadUri}${attach.sasToken}`)
}
export const getChangeOrderHistory = async (changeOrderId: number) => {
	const result = await getAll<ChangeOrderEvent[]>(`/ChangeOrders/${changeOrderId}/History`)
	return result.data
}

export const addChangeOrderHistoryEntry = async (
	surveyId: number,
	status: string,
	notes: string,
) => {
	try {
		const result = await post(`/ChangeOrders/Survey/${surveyId}/History`, {
			status,
			notes,
		})
		return result.success
	} catch (error : any) {
		showErrorToast(error)
		return false
	}
}
export const createChangeOrder = async (request: ManualChangeOrder) => {
	const response = await post(`/ChangeOrders/Manual`, request)
	return response.success
}

export const reviseChangeOrder = async (changeOrderId: number, request: ManualChangeOrder) => {
	const response = await post(`/ChangeOrders/${changeOrderId}/Revision`, request)
	return response.success
}

export const getRevisionsOfChangeOrder = async (changeOrderId: number) => {
	const response = await getAll<ChangeOrder[]>(`/ChangeOrders/${changeOrderId}/Revisions`)
	return response.data
}